
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { API_URL } from "../../Constants";

// export const Queries = () => {
//   const [queries, setQueries] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState('all');

//   const fetchQueries = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${API_URL}/api/admin/contact/queries`);
//       setQueries(response.data);
//     } catch (error) {
//       console.error("Error fetching queries:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchQueries();
//   }, []);

//   const handleResolve = async (id) => {
//     try {
//       await axios.put(`${API_URL}/api/admin/contact/queries/${id}/resolve`, { resolved: true });
//       setQueries(prev => prev.map(q => q.id === id ? { ...q, resolved: true } : q));
//     } catch (error) {
//       alert("Failed to update status");
//     }
//   };

//   const filteredQueries = queries.filter(q => {
//     if (filter === 'pending') return !q.resolved;
//     if (filter === 'resolved') return q.resolved;
//     return true;
//   });

//   return (
//     <div className="p-8 min-h-screen" style={{ backgroundColor: '#F0EFEB' }}>
//       <div className="max-w-full mx-auto bg-white rounded-2xl shadow-md overflow-hidden border border-gray-200">
        
//         {/* Table Header & Filters */}
//         <div className="px-8 py-6 border-b border-gray-100 flex justify-between items-center">
//           <h2 className="text-2xl font-semibold text-gray-800 tracking-tight">Queries</h2>
//           <div className="flex bg-gray-100 p-1 rounded-xl">
//             {['all', 'pending', 'resolved'].map((tab) => (
//               <button
//                 key={tab}
//                 onClick={() => setFilter(tab)}
//                 className={`px-5 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all ${
//                   filter === tab 
//                   ? 'bg-[#0C4550] text-[#C5F637] shadow-sm' 
//                   : 'text-gray-500 hover:text-gray-700'
//                 }`}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* New Table Structure */}
//         <div className="overflow-x-auto">
//           {loading ? (
//             <div className="p-20 text-center font-medium text-gray-400 animate-pulse">Loading data...</div>
//           ) : (
//             <table className="w-full text-left border-separate border-spacing-0">
//               <thead>
//                 <tr className="bg-gray-50">
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Name</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Email</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Phone No.</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Subject</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Message</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-center">Status</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-right">Action</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {filteredQueries.map((query) => (
//                   <tr key={query.id} className="hover:bg-indigo-50/30 transition-colors group">
//                     <td className="px-6 py-5 text-sm font-semibold text-gray-800">{query.name}</td>
//                     <td className="px-6 py-5 text-sm text-gray-600 font-medium">{query.email}</td>
//                     <td className="px-6 py-5 text-sm text-gray-500 font-mono">{query.phone}</td>
//                     <td className="px-6 py-5 text-sm font-medium text-gray-700">{query.subject}</td>
//                     <td className="px-6 py-5 text-sm text-gray-500 italic max-w-xs truncate">
//                       "{query.message}"
//                     </td>
//                     <td className="px-6 py-5 text-center">
//                       <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${
//                         query.resolved 
//                         ? 'bg-green-100 text-green-700' 
//                         : 'bg-orange-100 text-orange-700'
//                       }`}>
//                         <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${query.resolved ? 'bg-green-500' : 'bg-orange-500'}`}></span>
//                         {query.resolved ? 'RESOLVED' : 'PENDING'}
//                       </span>
//                     </td>
//                     <td className="px-6 py-5 text-right">
//                       {!query.resolved ? (
//                         <button
//                           onClick={() => handleResolve(query.id)}
//                           className="bg-[#0C4550] text-white text-[10px] font-semibold uppercase px-4 py-2 rounded-lg shadow-sm hover:shadow-md transition-all active:scale-95"
//                         >
//                           Resolve
//                         </button>
//                       ) : (
//                         <span className="text-gray-500 text-xs font-medium">Completed</span>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}

//           {!loading && filteredQueries.length === 0 && (
//             <div className="p-20 text-center">
//               <p className="text-gray-400 font-medium italic">No matching queries found.</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };




// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { API_URL } from "../../Constants";
// // Added Lucide icons for a professional look
// import { Eye, CheckCircle, Clock, List, X } from 'lucide-react';

// export const Queries = () => {
//   const [queries, setQueries] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState('all');
  
//   // States for the View Message Modal
//   const [selectedMessage, setSelectedMessage] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const fetchQueries = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${API_URL}/api/admin/contact/queries`);
//       setQueries(response.data);
//     } catch (error) {
//       console.error("Error fetching queries:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchQueries();
//   }, []);

//   const handleResolve = async (id) => {
//     try {
//       await axios.put(`${API_URL}/api/admin/contact/queries/${id}/resolve`, { resolved: true });
//       setQueries(prev => prev.map(q => q.id === id ? { ...q, resolved: true } : q));
//     } catch (error) {
//       alert("Failed to update status");
//     }
//   };

//   const openModal = (message) => {
//     setSelectedMessage(message);
//     setIsModalOpen(true);
//   };

//   const filteredQueries = queries.filter(q => {
//     if (filter === 'pending') return !q.resolved;
//     if (filter === 'resolved') return q.resolved;
//     return true;
//   });

//   // Icon mapping for tabs
//   const getTabIcon = (tab) => {
//     switch(tab) {
//       case 'all': return <List size={14} className="mr-1.5" />;
//       case 'pending': return <Clock size={14} className="mr-1.5" />;
//       case 'resolved': return <CheckCircle size={14} className="mr-1.5" />;
//       default: return null;
//     }
//   };

//   return (
//     <div className="p-8 min-h-screen" style={{ backgroundColor: '#F0EFEB' }}>
//       <div className="max-w-full mx-auto bg-white rounded-2xl shadow-md overflow-hidden border border-gray-200">
        
//         {/* Table Header & Filters */}
//         <div className="px-8 py-6 border-b border-gray-100 flex justify-between items-center">
//           <h2 className="text-2xl font-semibold text-gray-800 tracking-tight">Queries</h2>
//           <div className="flex bg-gray-100 p-1 rounded-xl">
//             {['all', 'pending', 'resolved'].map((tab) => (
//               <button
//                 key={tab}
//                 onClick={() => setFilter(tab)}
//                 className={`flex items-center px-4 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all ${
//                   filter === tab 
//                   ? 'bg-[#0C4550] text-[#C5F637] shadow-md scale-105' 
//                   : 'text-gray-500 hover:text-gray-700'
//                 }`}
//               >
//                 {getTabIcon(tab)}
//                 {tab}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className="overflow-x-auto">
//           {loading ? (
//             <div className="p-20 text-center font-medium text-gray-400 animate-pulse">Loading data...</div>
//           ) : (
//             <table className="w-full text-left border-separate border-spacing-0">
//               <thead>
//                 <tr className="bg-gray-50">
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Name</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Email</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Phone No.</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-center">Message</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-center">Status</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-right">Action</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {filteredQueries.map((query) => (
//                   <tr key={query.id} className="hover:bg-indigo-50/30 transition-colors group">
//                     <td className="px-6 py-5 text-sm font-semibold text-gray-800">{query.name}</td>
//                     <td className="px-6 py-5 text-sm text-gray-600 font-medium">{query.email}</td>
//                     <td className="px-6 py-5 text-sm text-gray-500 font-mono">{query.phone}</td>
                    
//                     {/* Updated Message Column with Eye Icon */}
//                     <td className="px-6 py-5 text-sm text-center">
//                       <div className="flex items-center justify-center gap-2">
//                         <span className="text-gray-400 italic max-w-[100px] truncate">
//                           {query.message.substring(0, 15)}...
//                         </span>
//                         <button 
//                           onClick={() => openModal(query.message)}
//                           className="p-1.5 rounded-full hover:bg-gray-200 text-[#0C4550] transition-colors"
//                           title="View Full Message"
//                         >
//                           <Eye size={18} />
//                         </button>
//                       </div>
//                     </td>

//                     <td className="px-6 py-5 text-center">
//                       <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${
//                         query.resolved ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
//                       }`}>
//                         <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${query.resolved ? 'bg-green-500' : 'bg-orange-500'}`}></span>
//                         {query.resolved ? 'RESOLVED' : 'PENDING'}
//                       </span>
//                     </td>

//                     <td className="px-6 py-5 text-right">
//                       {!query.resolved ? (
//                         <button
//                           onClick={() => handleResolve(query.id)}
//                           className="bg-[#0C4550] text-white text-[10px] font-semibold uppercase px-4 py-2 rounded-lg shadow-sm 
//                                      hover:-translate-y-1  transition-all duration-300 active:scale-95"
//                         >
//                           Resolve
//                         </button>
//                       ) : (
//                         <div className="flex items-center justify-end text-green-600 font-bold text-[10px] uppercase">
//                           <CheckCircle size={14} className="mr-1" /> Completed
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </div>

//       {/* --- Simple Modal for Message Viewing --- */}
//       {isModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl transform transition-all scale-100">
//             <div className="flex justify-between items-center p-6 border-b">
//               <h3 className="text-lg font-bold text-gray-800">Message Details</h3>
//               <button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-gray-600">
//                 <X size={24} />
//               </button>
//             </div>
//             <div className="p-6">
//               <p className="text-gray-600 leading-relaxed whitespace-pre-wrap">
//                 {selectedMessage}
//               </p>
//             </div>
//             <div className="p-4 bg-gray-50 text-right rounded-b-2xl">
//               <button 
//                 onClick={() => setIsModalOpen(false)}
//                 className="px-6 py-2 bg-gray-800 text-white rounded-lg text-sm font-semibold hover:bg-gray-700 transition-colors"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };





// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { API_URL } from "../../Constants";
// // Added Lucide icons for a professional look
// import { Eye, CheckCircle, Clock, List, X } from 'lucide-react';

// export const Queries = () => {
//   const [queries, setQueries] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState('all');
  
//   // States for the View Message Modal
//   const [selectedMessage, setSelectedMessage] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const fetchQueries = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${API_URL}/api/admin/contact/queries`);
//       setQueries(response.data);
//     } catch (error) {
//       console.error("Error fetching queries:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchQueries();
//   }, []);

//   const handleResolve = async (id) => {
//     try {
//       await axios.put(`${API_URL}/api/admin/contact/queries/${id}/resolve`, { resolved: true });
//       setQueries(prev => prev.map(q => q.id === id ? { ...q, resolved: true } : q));
//     } catch (error) {
//       alert("Failed to update status");
//     }
//   };

//   const openModal = (message) => {
//     setSelectedMessage(message);
//     setIsModalOpen(true);
//   };

//   const filteredQueries = queries.filter(q => {
//     if (filter === 'pending') return !q.resolved;
//     if (filter === 'resolved') return q.resolved;
//     return true;
//   });

//   // Icon mapping for tabs
//   const getTabIcon = (tab) => {
//     switch(tab) {
//       case 'all': return <List size={14} className="mr-1.5" />;
//       case 'pending': return <Clock size={14} className="mr-1.5" />;
//       case 'resolved': return <CheckCircle size={14} className="mr-1.5" />;
//       default: return null;
//     }
//   };

//   return (
//     <div className="p-8 min-h-screen" style={{ backgroundColor: '#F0EFEB' }}>
//       <div className="max-w-full mx-auto bg-white rounded-2xl shadow-md overflow-hidden border border-gray-200">
        
//         {/* Table Header & Filters */}
//         <div className="px-8 py-6 border-b border-gray-100 flex justify-between items-center">
//           <h2 className="text-2xl font-semibold text-gray-800 tracking-tight">Queries</h2>
//           <div className="flex bg-gray-100 p-1 rounded-xl">
//             {['all', 'pending', 'resolved'].map((tab) => (
//               <button
//                 key={tab}
//                 onClick={() => setFilter(tab)}
//                 className={`flex items-center px-4 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all ${
//                   filter === tab 
//                   ? 'bg-[#0C4550] text-[#C5F637] shadow-md scale-105' 
//                   : 'text-gray-500 hover:text-gray-700'
//                 }`}
//               >
//                 {getTabIcon(tab)}
//                 {tab}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className="overflow-x-auto">
//           {loading ? (
//             <div className="p-20 text-center font-medium text-gray-400 animate-pulse">Loading data...</div>
//           ) : filteredQueries.length === 0 ? (
//             <div className="p-20 text-center">
//               <div className="text-gray-400 mb-2">
//                 {filter === 'pending' ? (
//                   <div className="flex flex-col items-center justify-center">
//                     <CheckCircle size={48} className="text-gray-300 mb-4" />
//                     <p className="text-lg font-medium text-gray-500">No pending queries found</p>
//                     <p className="text-sm text-gray-400 mt-1">All queries are resolved</p>
//                   </div>
//                 ) : (
//                   <div className="flex flex-col items-center justify-center">
//                     <List size={48} className="text-gray-300 mb-4" />
//                     <p className="text-lg font-medium text-gray-500">No matching queries found</p>
//                     <p className="text-sm text-gray-400 mt-1">Try changing your filter settings</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           ) : (
//             <table className="w-full text-left border-separate border-spacing-0">
//               <thead>
//                 <tr className="bg-gray-50">
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Name</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Email</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Phone No.</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Subject</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-center">Message</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-center">Status</th>
//                   <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-right">Action</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {filteredQueries.map((query) => (
//                   <tr key={query.id} className="hover:bg-indigo-50/30 transition-colors group">
//                     <td className="px-6 py-5 text-sm font-semibold text-gray-800">{query.name}</td>
//                     <td className="px-6 py-5 text-sm text-gray-600 font-medium">{query.email}</td>
//                     <td className="px-6 py-5 text-sm text-gray-500 font-mono">{query.phone}</td>
                    
//                     {/* Subject Column */}
//                     <td className="px-6 py-5 text-sm text-gray-700 font-medium">
//                       <span className="truncate max-w-[120px] inline-block align-middle">
//                         {query.subject || "No Subject"}
//                       </span>
//                     </td>
                    
//                     {/* Updated Message Column with Eye Icon aligned in straight line */}
//                     <td className="px-6 py-5 text-sm">
//                       <div className="flex items-center justify-center gap-2">
//                         <span className="text-gray-400 italic max-w-[100px] truncate text-center">
//                           {query.message.substring(0, 15)}...
//                         </span>
//                         <button 
//                           onClick={() => openModal(query.message)}
//                           className="p-1.5 rounded-full hover:bg-gray-200 text-[#0C4550] transition-colors flex-shrink-0"
//                           title="View Full Message"
//                         >
//                           <Eye size={18} />
//                         </button>
//                       </div>
//                     </td>

//                     <td className="px-6 py-5 text-center">
//                       <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${
//                         query.resolved ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
//                       }`}>
//                         <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${query.resolved ? 'bg-green-500' : 'bg-orange-500'}`}></span>
//                         {query.resolved ? 'RESOLVED' : 'PENDING'}
//                       </span>
//                     </td>

//                     <td className="px-6 py-5 text-right">
//                       {!query.resolved ? (
//                         <button
//                           onClick={() => handleResolve(query.id)}
//                           className="bg-[#0C4550] text-white text-[10px] font-semibold uppercase px-4 py-2 rounded-lg shadow-sm 
//                                    hover:-translate-y-1  transition-all duration-300 active:scale-95"
//                         >
//                           Resolve
//                         </button>
//                       ) : (
//                         <div className="flex items-center justify-end text-green-600 font-bold text-[10px] uppercase">
//                           <CheckCircle size={14} className="mr-1" /> Completed
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </div>

//       {/* --- Simple Modal for Message Viewing --- */}
//       {isModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl transform transition-all scale-100">
//             <div className="flex justify-between items-center p-6 border-b">
//               <h3 className="text-lg font-bold text-gray-800">Message Details</h3>
//               <button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-gray-600">
//                 <X size={24} />
//               </button>
//             </div>
//             <div className="p-6">
//               <p className="text-gray-600 leading-relaxed whitespace-pre-wrap">
//                 {selectedMessage}
//               </p>
//             </div>
//             <div className="p-4 bg-gray-50 text-right rounded-b-2xl">
//               <button 
//                 onClick={() => setIsModalOpen(false)}
//                 className="px-6 py-2 bg-gray-800 text-white rounded-lg text-sm font-semibold hover:bg-gray-700 transition-colors"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from "../../Constants";
import { 
  Eye, CheckCircle, Clock, List, X, 
  Mail, Phone, Calendar, 
  XCircle, CheckSquare, AlertCircle 
} from 'lucide-react';

export const Queries = () => {
  const [activeSection, setActiveSection] = useState('registrations'); // 'registrations' or 'contact'
  const [registrations, setRegistrations] = useState([]);
  const [contactQueries, setContactQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('ALL');
  
  // Pagination States
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  
  // States for the View Message Modal
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      if (activeSection === 'registrations') {
        const response = await axios.get(
          `${API_URL}/api/v1/admin/requests/registrations?page=${page}&size=${size}&sortBy=createdAt&sortDir=desc`
        );
        setRegistrations(response.data.data.content);
        setTotalPages(response.data.data.totalPages);
        setTotalElements(response.data.data.totalElements);
      } else {
        const response = await axios.get(
          `${API_URL}/api/v1/admin/requests/contact?page=${page}&size=${size}&sortBy=createdAt&sortDir=desc`
        );
        setContactQueries(response.data.data.content);
        setTotalPages(response.data.data.totalPages);
        setTotalElements(response.data.data.totalElements);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activeSection, page, size]);

  const handleStatusUpdate = async (id, newStatus) => {
    try {
      if (activeSection === 'registrations') {
        await axios.patch(`${API_URL}/api/v1/admin/requests/registration/${id}/status`, {
          status: newStatus
        });
        setRegistrations(prev =>
          prev.map(item => (item.id === id ? { ...item, status: newStatus } : item))
        );
      } else {
        await axios.patch(`${API_URL}/api/v1/admin/requests/contact/${id}/status`, {
          status: newStatus
        });
        setContactQueries(prev =>
          prev.map(item => (item.id === id ? { ...item, status: newStatus } : item))
        );
      }
    } catch (error) {
      alert("Failed to update status");
    }
  };

  const openModal = (message) => {
    setSelectedMessage(message);
    setIsModalOpen(true);
  };

  const getTabs = () => {
    if (activeSection === 'registrations') {
      return ['ALL', 'PENDING', 'APPROVED', 'REJECTED'];
    }
    return ['ALL', 'UNREAD', 'RESOLVED'];
  };

  const getTabIcon = (tab) => {
    switch (tab) {
      case 'ALL':
        return <List size={14} className="mr-1.5" />;
      case 'PENDING':
      case 'UNREAD':
        return <Clock size={14} className="mr-1.5" />;
      case 'APPROVED':
      case 'RESOLVED':
        return <CheckCircle size={14} className="mr-1.5" />;
      case 'REJECTED':
        return <XCircle size={14} className="mr-1.5" />;
      default:
        return null;
    }
  };

  const currentData = activeSection === 'registrations' ? registrations : contactQueries;
  
  const filteredData = currentData.filter(item => {
    if (filter === 'ALL') return true;
    return item.status === filter;
  });

  return (
    <div className="p-8 min-h-screen" style={{ backgroundColor: '#F0EFEB' }}>
      <div className="max-w-full mx-auto bg-white rounded-2xl shadow-md overflow-hidden border border-gray-200">
        
        {/* Section Navigation Header */}
        <div className="flex border-b border-gray-200 bg-gray-50/50 justify-between items-center px-8 py-4">
          
          {/* Custom Theme Tabs */}
          <div className="flex gap-2 bg-white/60 p-1.5 rounded-xl border border-white shadow-sm w-fit">
            <button
              onClick={() => { setActiveSection('registrations'); setPage(0); setFilter('ALL'); }}
              className={`px-6 py-2 rounded-lg text-sm font-medium font-manrope transition-all duration-300 ${
                activeSection === 'registrations' 
                  ? 'bg-[#0C4550] text-white shadow-md' 
                  : 'text-[#0C4550] hover:bg-[#0C4550]/10'
              }`}
            >
              Registrations
            </button>
            <button
              onClick={() => { setActiveSection('contact'); setPage(0); setFilter('ALL'); }}
              className={`px-6 py-2 rounded-lg text-sm font-medium font-manrope transition-all duration-300 ${
                activeSection === 'contact' 
                  ? 'bg-[#0C4550] text-white shadow-md' 
                  : 'text-[#0C4550] hover:bg-[#0C4550]/10'
              }`}
            >
              Contact Queries
            </button>
          </div>

          {/* Sub-Filters */}
          <div className="flex bg-gray-100 p-1 rounded-xl">
            {getTabs().map((tab) => (
              <button
                key={tab}
                onClick={() => setFilter(tab)}
                className={`flex items-center px-4 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all ${
                  filter === tab 
                    ? 'bg-[#0C4550] text-[#C5F637] shadow-md scale-105' 
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                {getTabIcon(tab)}
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="overflow-x-auto">
          {loading ? (
            <div className="p-20 text-center font-medium text-gray-400 animate-pulse">Loading data...</div>
          ) : filteredData.length === 0 ? (
            <div className="p-20 text-center">
              <div className="flex flex-col items-center justify-center text-gray-400">
                <AlertCircle size={48} className="text-gray-300 mb-4" />
                <p className="text-lg font-medium text-gray-500">No {filter.toLowerCase()} queries found</p>
                <p className="text-sm text-gray-400 mt-1">Try changing your filter or check back later.</p>
              </div>
            </div>
          ) : (
            <table className="w-full text-left border-separate border-spacing-0">
              <thead>
                <tr className="bg-gray-50">
                  {activeSection === 'registrations' ? (
                    <>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Name</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Email</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Phone No.</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Company</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-center">Status</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-right">Action</th>
                    </>
                  ) : (
                    <>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Full Name</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Email</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Phone No.</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b">Subject</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-center">Message</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-center">Status</th>
                      <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase border-b text-right">Action</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredData.map((query) => (
                  <tr key={query.id} className="hover:bg-indigo-50/30 transition-colors group">
                    {/* Render Registrations Data */}
                    {activeSection === 'registrations' ? (
                      <>
                        <td className="px-6 py-5 text-sm font-semibold text-gray-800">
                          {query.firstName} {query.lastName}
                        </td>
                        <td className="px-6 py-5 text-sm text-gray-600 font-medium">{query.email}</td>
                        <td className="px-6 py-5 text-sm text-gray-500 font-mono">{query.phone}</td>
                        <td className="px-6 py-5 text-sm text-gray-700 font-medium">{query.companyName || "N/A"}</td>
                        <td className="px-6 py-5 text-center">
                          <span
                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${
                              query.status === 'APPROVED'
                                ? 'bg-green-100 text-green-700'
                                : query.status === 'REJECTED'
                                ? 'bg-red-100 text-red-700'
                                : 'bg-orange-100 text-orange-700'
                            }`}
                          >
                            <span
                              className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                                query.status === 'APPROVED'
                                  ? 'bg-green-500'
                                  : query.status === 'REJECTED'
                                  ? 'bg-red-500'
                                  : 'bg-orange-500'
                              }`}
                            ></span>
                            {query.status}
                          </span>
                        </td>
                        <td className="px-6 py-5 text-right">
                          {query.status === 'PENDING' ? (
                            <div className="flex items-center justify-end gap-2">
                              <button
                                onClick={() => handleStatusUpdate(query.id, 'APPROVED')}
                                className="bg-[#0C4550] text-white text-[10px] font-semibold uppercase px-3 py-2 rounded-lg shadow-sm hover:-translate-y-0.5 transition-all duration-300 active:scale-95 flex items-center gap-1"
                              >
                                <CheckSquare size={12} /> Appr.
                              </button>
                              <button
                                onClick={() => handleStatusUpdate(query.id, 'REJECTED')}
                                className="bg-red-500 text-white text-[10px] font-semibold uppercase px-3 py-2 rounded-lg shadow-sm hover:-translate-y-0.5 transition-all duration-300 active:scale-95 flex items-center gap-1"
                              >
                                <XCircle size={12} /> Rej.
                              </button>
                            </div>
                          ) : (
                            <div className="flex items-center justify-end text-xs font-bold uppercase">
                              {query.status === 'APPROVED' ? (
                                <span className="text-green-600 flex items-center gap-1">
                                  <CheckCircle size={14} /> Approved
                                </span>
                              ) : (
                                <span className="text-red-600 flex items-center gap-1">
                                  <XCircle size={14} /> Rejected
                                </span>
                              )}
                            </div>
                          )}
                        </td>
                      </>
                    ) : (
                      /* Render Contact Queries Data */
                      <>
                        <td className="px-6 py-5 text-sm font-semibold text-gray-800">{query.fullName}</td>
                        <td className="px-6 py-5 text-sm text-gray-600 font-medium">{query.email}</td>
                        <td className="px-6 py-5 text-sm text-gray-500 font-mono">{query.phoneNumber}</td>
                        <td className="px-6 py-5 text-sm text-gray-700 font-medium">
                          <span className="truncate max-w-[120px] inline-block align-middle">
                            {query.subject || "No Subject"}
                          </span>
                        </td>
                        <td className="px-6 py-5 text-sm flex items-center justify-center gap-2">
                          <span className="text-gray-400 italic max-w-[100px] truncate text-center">
                            {query.message.substring(0, 15)}...
                          </span>
                          <button
                            onClick={() => openModal(query.message)}
                            className="p-1.5 rounded-full hover:bg-gray-200 text-[#0C4550] transition-colors flex-shrink-0"
                            title="View Full Message"
                          >
                            <Eye size={18} />
                          </button>
                        </td>
                        <td className="px-6 py-5 text-center">
                          <span
                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${
                              query.status === 'RESOLVED' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
                            }`}
                          >
                            <span
                              className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                                query.status === 'RESOLVED' ? 'bg-green-500' : 'bg-orange-500'
                              }`}
                            ></span>
                            {query.status}
                          </span>
                        </td>
                        <td className="px-6 py-5 text-right">
                          {query.status === 'UNREAD' ? (
                            <button
                              onClick={() => handleStatusUpdate(query.id, 'RESOLVED')}
                              className="bg-[#0C4550] text-white text-[10px] font-semibold uppercase px-4 py-2 rounded-lg shadow-sm hover:-translate-y-1 transition-all duration-300 active:scale-95"
                            >
                              Resolve
                            </button>
                          ) : (
                            <div className="flex items-center justify-end text-green-600 font-bold text-[10px] uppercase">
                              <CheckCircle size={14} className="mr-1" /> Resolved
                            </div>
                          )}
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination & Details Controller */}
        {!loading && totalPages > 1 && (
          <div className="px-8 py-4 bg-gray-50 border-t border-gray-200 flex justify-between items-center text-xs font-semibold text-gray-600">
            <div>
              Showing <span className="text-[#0C4550]">{(page * size) + 1}</span> to{' '}
              <span className="text-[#0C4550]">
                {Math.min((page + 1) * size, totalElements)}
              </span> of <span className="text-[#0C4550]">{totalElements}</span> entries
            </div>
            <div className="flex items-center gap-2">
              <button
                disabled={page === 0}
                onClick={() => setPage(prev => Math.max(0, prev - 1))}
                className="px-3 py-1.5 bg-white border border-gray-300 rounded-md hover:bg-gray-100 disabled:opacity-50 text-gray-700"
              >
                Previous
              </button>
              <span className="px-2 text-gray-700">
                Page {page + 1} of {totalPages}
              </span>
              <button
                disabled={page + 1 >= totalPages}
                onClick={() => setPage(prev => prev + 1)}
                className="px-3 py-1.5 bg-white border border-gray-300 rounded-md hover:bg-gray-100 disabled:opacity-50 text-gray-700"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      {/* --- Simple Modal for Message Viewing --- */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl transform transition-all scale-100">
            <div className="flex justify-between items-center p-6 border-b">
              <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
                <Mail size={20} className="text-[#0C4550]" /> Message Details
              </h3>
              <button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-gray-600">
                <X size={24} />
              </button>
            </div>
            <div className="p-6">
              <p className="text-gray-600 leading-relaxed whitespace-pre-wrap">
                {selectedMessage}
              </p>
            </div>
            <div className="p-4 bg-gray-50 text-right rounded-b-2xl">
              <button 
                onClick={() => setIsModalOpen(false)}
                className="px-6 py-2 bg-[#0C4550] text-white rounded-lg text-sm font-semibold hover:bg-[#0a353d] transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};